import {memo} from 'react'
import {useTranslation} from 'react-i18next'
import {Selection} from '../../../../../components/Selection'
import {TextInputV2} from '../../../../../components/TextInputV2'
import {useCities} from '../../../../../hooks/useCities'
import {useRegions} from '../../../../../hooks/useRegions'
import {useSalesOrganization} from '../../../../../hooks/useSalesOrganization'
import {useAppDispatch, useAppSelector} from '../../../../../redux/hooks'
import {priceSelector, setFilterJBP} from '../../../../../redux/slices/priceSlices'
import * as TableUI from '../../../../../components/Table/Table'

export const RowFilter = memo(() => {
  const {t} = useTranslation()
  const {filterJBP: filter} = useAppSelector(priceSelector)
  const dispatch = useAppDispatch()
  const {salesOrgOptions} = useSalesOrganization()
  const {options: regionOptions} = useRegions()
  const {options: citiesOptions} = useCities()

  const statusOptions = [
    {label: 'Active', value: 'true'},
    {label: 'Inactive', value: 'false'},
  ]

  const handleChange = (value: Partial<typeof filter>) => {
    dispatch(setFilterJBP({...filter, ...value}))
  }

  return (
    <TableUI.TRowFilter>
      <td>
        <div>&nbsp;</div>
      </td>
      <td>
        <TextInputV2
          placeholder={t('Sales Org Code')}
          value={filter?.sales_org_code2 ?? ''}
          onChange={({target}) => handleChange({sales_org_code2: target.value})}
        />
      </td>
      <td>
        <Selection
          placeholder={'Sales Org'}
          data={salesOrgOptions}
          value={filter?.sales_org_code ?? ''}
          onChange={(sales_org_code) => handleChange({sales_org_code})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Customer Code')}
          value={filter?.customer_code ?? ''}
          onChange={({target}) => handleChange({customer_code: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Customer Name')}
          value={filter?.customer_name ?? ''}
          onChange={({target}) => handleChange({customer_name: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Product Code')}
          value={filter?.product_code ?? ''}
          onChange={({target}) => handleChange({product_code: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('kontrak-nama')}
          value={filter?.product_name ?? ''}
          onChange={({target}) => handleChange({product_name: target.value})}
        />
      </td>
      <td>
        <Selection
          placeholder={t('Region Name')}
          data={regionOptions}
          value={filter?.sales_org_code ?? ''}
          onChange={(value: any) => handleChange({region_name: value ?? ''})}
        />
      </td>
      <td>
        <Selection
          placeholder={t('City Name')}
          data={citiesOptions}
          value={filter?.city_name ?? ''}
          onChange={(value: any) => handleChange({city_name: value ?? ''})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={'Minimum ' + t('Harga')}
          value={filter?.minimum_price ?? ''}
          onChange={({target}) => handleChange({minimum_price: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Selling Price')}
          value={filter?.selling_price ?? ''}
          onChange={({target}) => handleChange({selling_price: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Discount')}
          value={filter?.discount ?? ''}
          onChange={({target}) => handleChange({discount: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Purchase Price')}
          value={filter?.purchase_price ?? ''}
          onChange={({target}) => handleChange({purchase_price: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('deskrisi')}
          value={filter?.description ?? ''}
          onChange={({target}) => handleChange({description: target.value})}
        />
      </td>
      <td>
        <Selection
          data={statusOptions}
          placeholder={'Status'}
          value={filter?.is_active ?? ''}
          onChange={(is_active) => handleChange({is_active})}
        />
      </td>
      <td>
        <div>&nbsp;</div>
      </td>
    </TableUI.TRowFilter>
  )
})
